import React from 'react';
import { 
  Typography,
  Box,
  Divider,
} from '@mui/material';
import autovalid360PlanGreen from '../../assets/images/autovalid360_plan_green.svg';

const SERVICES_HISTORICO = [
  'Pesquisa de procedência;',
  'Leilão;',
  'Sinistro;',
  'Furto;',
  'Impedimentos;',
  'Restrições judiciais;',
  'Débitos.'
];

const SERVICES_IDENTIFICACAO = [
  'Conferência dos itens do veículo;',
  'Chassi;',
  'Numeração do motor;',
  'Etiquetas;',
  'Lacres;',
  'Km;',
  'Verificação de originalidade ou troca dos vidros.'
];

const SERVICES_ESTRUTURA = [
  'Análise de carroceria, pintura:',
  'Indícios de colisão;',
  'Repintura;',
  'Lanternagem e recuperação;',
  'Verificação dos pontos estruturais:',
  'Longarinas;',
  'Colunas;',
  'Painéis.'
];

// 2. Componentes reutilizáveis
const ServiceItem = React.memo(({ text }) => (
  <Box 
    component="li" 
    sx={{
      display: 'flex',
      alignItems: 'center',
      mb: 0,
      fontWeight: 100,
      '&::before': {
        content: '"•"',
        fontWeight: 'bold',
        display: 'inline-block',
        width: '1em',
        marginLeft: '0.5em'
      }
    }}
  >
    {text}
  </Box>
));

const ServiceSection = ({ title, items }) => (
  <Box sx={{ mb: 3 }}>
    <Typography 
      variant="h6" 
      sx={{ 
        color: '#012F47',
        fontWeight: 600,
        mb: 1
      }}
    >
      {title}
    </Typography>
    <Box component="ul" sx={{ 
      listStyle: 'none',
      p: 0,
      m: 0
    }}>
      {items.map((item, index) => (
        <ServiceItem key={index} text={item} />
      ))}
    </Box>
  </Box>
);

// 5. Componente principal otimizado
export default function PremiumPlanCard() {
  return (
    <Box sx={{ 
      bgcolor: '#FFFFFF',
      borderRadius: { xs: 2, sm: 3, md: 4 },
      p: { xs: 2, sm: 3, md: 4 },
      boxShadow: '0px 6px 24px 0px #012F473A',
      height: '100%',
    }}>
      {/* Logo */}
      <Box sx={{ 
        textAlign: 'center',
        mb: 3
      }}>
        <img 
          src={autovalid360PlanGreen} 
          alt="Autovalid 360 Premium Plan" 
          style={{ maxWidth: '200px' }}
        />
      </Box>

      {/* Linha divisória gradiente */}
      <Divider 
        sx={{ 
          height: '4px',
          mb: 3,
          background: 'linear-gradient(89.96deg, #00B26C -1.43%, #259EC9 106.6%)'
        }} 
      />

      {/* Seções de serviços */}
      <Box sx={{ 
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
        gap: 3
      }}>
        <Box>
          <ServiceSection title="Histórico Veicular" items={SERVICES_HISTORICO} />
          <ServiceSection title="Identificação" items={SERVICES_IDENTIFICACAO} />
        </Box>
        
        <Box>
          <ServiceSection title="Estrutura" items={SERVICES_ESTRUTURA} />
          
          <ServiceSection 
            title="Laudo Técnico" 
            items={['Emissão de laudo com registros fotográficos de todos os itens consultados e inspecionados.']} 
          />
          
          <ServiceSection 
            title="Diagnóstico" 
            items={['Diagnóstico completo do motor.']} 
          />
        </Box>
      </Box>
    </Box>
  );
}